export default __webpack_public_path__ + "static/media/closeButtonIcon.c5a1ca12.svg";